import '../scss/duzebiuro.scss';

import 'parsleyjs';
import 'parsleyjs/dist/i18n/pl';

console.log('Loaded: duzebiuro.js');

const form = $('#form-duze-biuro');
const message = $('.validate-message');

// Numer NIP do testow selenium
const testNip = '7822436460';

const companyLabel = form.find('label[for="company"]');
const companyInput = form.find('[name="company"]');

form.find('[name="profile"]').on('change', function() {
    if($(this).val() === 'Osoba prywatna') {
        companyInput[0].removeAttribute('required');
        companyLabel.find('span').remove();
        companyInput.removeClass('parsley-error').next('ul').remove();
    } else if(companyInput[0].getAttribute('required') === null) {
        companyInput[0].setAttribute('required', true);
        companyLabel.append('<span class="required">*</span>');
    }
});

form.parsley();

window.Parsley.addValidator('nip', {
    validateString: function(nip) {
        const nipWithoutDashes = nip.replace(/-/g,"").trim();
        const reg = /^[0-9]{10}$/;

        if(reg.test(nipWithoutDashes) === false) {
            return false;}
        else
        {
            const digits = (""+nipWithoutDashes).split("");
            const checksum = (6*parseInt(digits[0]) + 5*parseInt(digits[1]) + 7*parseInt(digits[2]) + 2*parseInt(digits[3]) + 3*parseInt(digits[4]) + 4*parseInt(digits[5]) + 5*parseInt(digits[6]) + 6*parseInt(digits[7]) + 7*parseInt(digits[8]))%11;

            return (parseInt(digits[9]) === checksum);
        }
    },
    messages: {
        pl: 'Niepoprawny numer NIP'
    }
});


form.on('submit', function(e) {
    e.preventDefault();
    send_form();
});


function send_form() {
    if(typeof form_send_url === 'undefined') return false;
    form.find('fieldset').removeAttr('disabled');

    $.ajax({
        type: 'POST',
        url: form_send_url,
        data: form.serialize(),
        success: function(response) {
            response = JSON.parse(response);

            if(response.success) {
                message.html('<div class="success">' + response.success + '</div>');
                $('.register-plain').remove();
                form.remove();
                $('html,body').scrollTop(0);
            } else {
                message.html('<div class="error">' + response.error + '</div>');
                $('html,body').scrollTop(0);
            }
        },
        error: function(error) {
            console.log(error);
        }
    })
}

if ($('.nip-validate-date').length) {
    $('.nip-validate-date').parsley().on('field:success', function() {

        $('.lp-form fieldset')[0].setAttribute('disabled', true);

        const fp_nip = this.value.replace(/-/g,"").trim();

        $.ajax({
            method: 'GET',
            url: 'https://secure.fillup.pl/gusapi/index.php?nip=' + fp_nip,
            success: function(response) {
                const data = JSON.parse(response);

                const registerAt = typeof data.fiz_dataRozpoczeciaDzialalnosci !== 'undefined' ? data.fiz_dataRozpoczeciaDzialalnosci : data.praw_dataRozpoczeciaDzialalnosci;
                const dateRegister = new Date(registerAt);
                const dateCurrent = new Date();
                const difference = Math.floor((dateCurrent - dateRegister) / (1000*60*60*24));

                if(fp_nip !== testNip && difference > 365) {
                    const text = `
						<div class="error">
							<h2>Data rejestracji Twojej firmy to: ${registerAt}.</p>
							<h3>Niestety, ale Twoja firma nie została zarejestrowana w ciągu ostatniego roku i nie może wziąć udziału w promocji</h3>
							<h4>Zapraszamy na stronę <a href="https://www.fillup.pl/pobierz-darmowy-program/">https://www.fillup.pl/pobierz-darmowy-program/</a> w celu pobrania programu fillup na 30 dni za darmo.</h4>
							<p>Przez 30 dni okresu próbnego&nbsp;korzystasz z pełnej funkcjonalności programu, możesz wypełniać, drukować, e-wysłać i zapisywać wszystkie formularze, tak jak byś kupił najwyższy&nbsp;<a href="https://www.fillup.pl/cennik/biuro/">abonament Duże Biuro (moduł formularze bazowe)</a>.</p>
							<p>Uwaga: W 30 dniowym okresie próbnym nie jest dostępny moduł e-Sprawozdania Finansowe, nie ma obsługi i wysyłki formularzy PIT-11 oraz nie ma formularzy z modułu Premium.</p>
							<p>Sprawdź fillup już teraz, pobierz lub uruchom program bez żadnych zobowiązań, a po wypełnieniu pierwszego druku, poprosimy Cię o rejestrację Twojego adresu e-mail, na który prześlemy do Ciebie darmowy kod aktywacji.</p>
							<p>Po zakończeniu okresu próbnego i wygaśnięciu darmowego kodu, będziesz mógł nadal korzystać z&nbsp;<a href="https://www.fillup.pl/darmowe-druki/">ponad 700 darmowych druków</a>, a formularze płatne opłacisz wybierając jeden z wygodnych pakietów abonamentowych dopasowanych do Twoich potrzeb lub skorzystasz tylko z jednego, wybranego druku&nbsp;(<a href="https://www.fillup.pl/cennik/sms/">SMS</a>).</p>
							<p style="text-align: right"><a href="https://www.fillup.pl/faq-fillup/30-dniowy-okres-testowy/">więcej informacji znajdziesz w dziale Pomoc&nbsp;&rsaquo;&nbsp;FAQ&nbsp;&raquo;</a></p>
						</div>
					`;

                    $('.lp-form').html(text);
                    $('.register-plain').remove();
                } else {
                    $('.lp-form fieldset')[0].removeAttribute('disabled');

                    const fp_name = data.Nazwa;
                    const fp_regon = data.Regon;

                    $('#company').val(fp_name);
                    $('#regon').val(fp_regon);
                }
            },
            error: function(error) {
                console.log(error);
            }
        });
    });
}